export default [
  {
    name: 'purchasesWelfareList',
    path: '/purchasesWelfare/list',
    component: () => import('@/views/purchasesWelfare/list.vue'),
    meta: {
      title: '内购福利'
    }
  },
  {
    name: 'internalPurchaseOrderManagerList',
    path: '/purchasesWelfare/orderList',
    component: () => import('@/views/purchasesWelfare/orderList.vue'),
    meta: {
      title: '内购订单管理'
    }
  },
  {
    name: 'internalPurchaseOrderManagerDetail',
    path: '/purchasesWelfare/orderDetail',
    component: () => import('@/views/purchasesWelfare/orderDetail.vue'),
    meta: {
      title: '内购订单详情',
      parentAuth: '/purchasesWelfare/orderList'
    }
  }
]
